export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9096.265ca54f.jpg";